<div [class]="alertType" *ngIf="alertMessage">
  {{ alertMessage }}
</div>
